import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { LogIn } from "lucide-react";
import api from "@/lib/api";

const formatError = (detail) => {
  if (detail == null) return "Login failed. Try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || "").filter(Boolean).join(" ");
  return String(detail);
};

export default function AdminLogin() {
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/login", form);
      toast.success("Welcome back!");
      navigate("/admin");
    } catch (err) {
      toast.error(formatError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  const input = "w-full bg-ink/40 border border-bone/15 rounded-xl px-4 py-3.5 text-sm text-bone placeholder:text-bone/30 focus:outline-none focus:border-sun transition-colors";

  return (
    <div className="min-h-screen bg-ink flex items-center justify-center px-4 grain relative" data-testid="admin-login-page">
      <div className="w-full max-w-sm">
        <p className="font-display text-3xl font-black text-bone text-center mb-2">click<span className="text-sun">2</span>trip</p>
        <p className="text-bone/40 text-sm text-center mb-10">Admin Console</p>
        <form onSubmit={submit} className="bg-bone/5 backdrop-blur-xl border border-bone/10 rounded-3xl p-8 space-y-4" data-testid="admin-login-form">
          <input type="email" required placeholder="Email" value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })} className={input} data-testid="admin-email-input" />
          <input type="password" required placeholder="Password" value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })} className={input} data-testid="admin-password-input" />
          <button type="submit" disabled={loading} data-testid="admin-login-submit-btn"
            className="w-full inline-flex items-center justify-center gap-2 bg-sun text-bone font-semibold py-3.5 rounded-full hover:bg-[#e85a28] transition-colors disabled:opacity-60">
            <LogIn size={16} /> {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
